module.exports = __webpack_public_path__ + "files/5f72c0f8cfcb9c5cdcfbbc706638b614.png";